<style>
.form-control:disabled,
.form-control[readonly] {
  background-color: white !important
}

.table th,
.table td {
  padding: 0.35rem!important;
}

.filterLogs {
  background-color: #ebeef0;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px
}
</style>
<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">

      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          <strong>Auditoria</strong><small v-show="searchExecuted"> (encontrado {{logs.length}} registros)</small>
          <button v-show="showFilters" type="button" class="btn btn-secondary btn-sm pull-right" exact @click="showFilters = !showFilters">
            <i class="fa fa-filter"></i> Ocultar Filtros
          </button>
          <button v-show="!showFilters" type="button" class="btn btn-secondary btn-sm pull-right" exact @click="showFilters = !showFilters">
            <i class="fa fa-filter"></i> Exibir Filtros
          </button>
        </div>
        <div class="card-block">
          <div v-show="showFilters" class="filterLogs">
            <b>Filtros</b>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">Componente </label>
                  <input type="text" class="form-control" name="component" v-model="filter.component">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">Usuário(email) </label>
                  <input type="text" class="form-control" name="component" v-model="filter.user">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">Status </label>
                  <input type="text" class="form-control" name="component" v-model="filter.status">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="col-form-label">Data Inicio </label>
              </div>
              <div class="col-md-2">
                <label class="col-form-label">Hora Inicio </label>
              </div>
              <div class="col-md-2">
                <label class="col-form-label">Minutos Inicio </label>
              </div>
              <div class="col-md-2">
                <label class="col-form-label">Data Fim </label>
              </div>
              <div class="col-md-2">
                <label class="col-form-label">Hora Fim </label>
              </div>
              <div class="col-md-2">
                <label class="col-form-label">Minutos Fim </label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <datepicker :bootstrapStyling="true" :format="customFormatter" v-model="filterStartDate.date" name="selectedDateUnique"></datepicker>
              </div>
              <div class="col-md-2">
                <select class="form-control input-sm" v-model="filterStartDate.hour">
                  <option v-for="(row, rowIndex) in hoursToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
              <div class="col-md-2">
                <select class="form-control input-sm" v-model="filterStartDate.minutes">
                  <option v-for="(row, rowIndex) in minutesToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
              <div class="col-md-2">
                <datepicker :bootstrapStyling="true" :format="customFormatter" v-model="filterEndDate.date" name="selectedDateUnique"></datepicker>
              </div>
              <div class="col-md-2">
                <select class="form-control input-sm" v-model="filterEndDate.hour">
                  <option v-for="(row, rowIndex) in hoursToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
              <div class="col-md-2">
                <select class="form-control input-sm" v-model="filterEndDate.minutes">
                  <option v-for="(row, rowIndex) in minutesToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-md-12">
                <button type="button" class="btn btn-secondary btn-sm pull-right" exact @click="getLogs()">
                  <i class="fa fa-search"></i> Buscar
                </button>
              </div>
            </div>
          </div>

          <table class="table table-bordered">
            <thead class="thead-inverse">
              <tr>
                <th>Usuário</th>
                <th>Email Usuário</th>
                <th>Componente</th>
                <th>Permissão</th>
                <th>Método</th>
                <th>Url Path</th>
                <th>Status</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in orderedItems">
                <td><span v-show="row.userFirstName">{{row.userFirstName }}</span><span v-show="!row.userFirstName">n/a</span></td>
                <td><span v-show="row.userEmail">{{row.userEmail}}</span><span v-show="!row.userEmail"> n/a </span></td>
                <td>{{row.component}}</td>
                <td>{{row.action}}</td>
                <td>{{row.method}}</td>
                <td>{{row.urlPath}}</td>
                <td>{{row.status}}</td>
                <td>{{row.date | formatDate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--Modal de filtros -->
    <modal title="Modal title" class="modal" v-model="filterModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Alterar parametros de busca</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="card">
          <div class="card-header">
            <strong class="pull-left">Filtros</strong>
            <button type="button" class="btn btn-sm btn-secondary pull-right" @click="getLogs()">Procurar</button>

          </div>
          <div class="card-block">
            <div class="form-group">
              <label class="col-form-label">Componente </label>
              <input type="text" class="form-control" name="component" v-model="filter.component">
            </div>
            <div class="form-group">
              <label class="col-form-label">Usuário(email) </label>
              <input type="text" class="form-control" name="component" v-model="filter.user">
            </div>
            <div class="form-group">
              <label class="col-form-label">Status </label>
              <input type="text" class="form-control" name="component" v-model="filter.status">
            </div>
            <label class="col-form-label">Data Início</label>
            <div class="row">
              <div class="col-md-5">
                <datepicker :bootstrapStyling="true" :format="customFormatter" v-model="filterStartDate.date" name="selectedDateUnique"></datepicker>
              </div>
              <div class="col-md-3">
                <select class="form-control input-sm" v-model="filterStartDate.hour">
                  <option v-for="(row, rowIndex) in hoursToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
              <div class="col-md-3">
                <select class="form-control input-sm" v-model="filterStartDate.minutes">
                  <option v-for="(row, rowIndex) in minutesToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
            </div>
            <label class="col-form-label">Data Fim</label>
            <div class="row">
              <div class="col-md-5">
                <datepicker :bootstrapStyling="true" :format="customFormatter" v-model="filterEndDate.date" name="selectedDateUnique"></datepicker>
              </div>
              <div class="col-md-3">
                <select class="form-control input-sm" v-model="filterEndDate.hour">
                  <option v-for="(row, rowIndex) in hoursToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
              <div class="col-md-3">
                <select class="form-control input-sm" v-model="filterEndDate.minutes">
                  <option v-for="(row, rowIndex) in minutesToSelect" :key="row" :value="row">{{row}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix" />
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="filterModal = false">Fechar</button>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import modal from 'vue-strap/src/Modal'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'logs',
  components: {
    modal, Datepicker
  },
  data() {
    return {
      loading: false,
      logs: [],
      filterModal: false,
      showFilters: true,
      filter: {},
      filterStartDate: {
        date: new Date(new Date().setDate(new Date().getDate() - 1)),
        hour: '00',
        minutes: '00'
      },
      filterEndDate: {
        date: new Date(),
        hour: '00',
        minutes: '00'
      },
      searchExecuted: false,
      hoursToSelect: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      minutesToSelect: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59']
    }
  },
  created() {
    this.filter = {}
  },
  computed: {
    orderedItems: function() {
      return this.logs.sort((a, b) => {
        return Date.parse(b.date) - Date.parse(a.date)
      })
    }
  },
  methods: {
    customFormatter(date) {
      return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
    },
    getLogs() {
      this.searchExecuted = false
      var queryString = '?'
      if (this.filter.component !== '' && this.filter.component !== undefined) {
        queryString += 'component=' + this.filter.component + '&'
      }
      if (this.filter.user !== '' && this.filter.user !== undefined) {
        queryString += 'user=' + this.filter.user + '&'
      }
      if (this.filter.status !== '' && this.filter.status !== undefined) {
        queryString += 'status=' + this.filter.status + '&'
      }
      var startDate = this.getISODate(this.filterStartDate.date, this.filterStartDate.hour, this.filterStartDate.minutes)
      var endDate = this.getISODate(this.filterEndDate.date, this.filterEndDate.hour, this.filterEndDate.minutes)
      queryString += 'startDate=' + startDate + '&'
      queryString += 'endDate=' + endDate + '&'
      axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'audit' + queryString, {
        withCredentials: true,
        headers: { Authorization: this.accessKey }
      }).then(response => {
        this.logs = response.data
        if (this.logs.length === 0) {
          this.showInfo('Não foi encontrado nenhum log com estes filtros')
        }
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar os logs.')
        this.filterModal = false
      })
      this.searchExecuted = true
    },
    showFilterModal() {
      this.filterModal = true
    },
    getISODate(date, hour, minutes) {
      var day = ('0' + date.getDate()).slice(-2)
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var year = date.getFullYear()
      var isoDate = year + '-' + month + '-' + day + 'T' + hour + ':' + minutes + ':00'
      return isoDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?ef5154de